export default "__VITE_ASSET__a6863ad2__"